import { render } from "./EarnTipsDialog.vue?vue&type=template&id=74e3002c&scoped=true"
import script from "./EarnTipsDialog.vue?vue&type=script&lang=js"
export * from "./EarnTipsDialog.vue?vue&type=script&lang=js"

import "./EarnTipsDialog.vue?vue&type=style&index=0&id=74e3002c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e3002c"]])

export default __exports__